<div class="loading">
    <div class="loading-tube">
        <img src="assets/img/ajax-loader.gif" alt="Loading..." />
    </div>
</div>
